<form [formGroup]="form">
    <table class="widget-settings_wrap">
        <!-- Widget Name -->
        <tr class="field">
            <td>
                <label class="label-text" for="widget_name">
                    {{'components.widgets.common.settings_widget_name' | l10n}}
                </label>
            </td>
            <td>
                <input class="text-input" type="text" id="widget_name" [formControl]="form.controls.title" autofocus />
            </td>
        </tr>
    </table>
    <columns-manager
        [columns]="tableColumnsDef"
        [formControl]="form.controls.columns">
    </columns-manager>
</form>
